import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import "./myc-categories-page.css";
import {
  get_is_myc_web,
  get_myc_catalogue_title,
  get_myc_is_secured,
  getCatMaster,
} from "../../redux/Reducer/reducer";
import {
  get_informationFromSessionID,
  get_property_settings,
} from "../../Component/Helper";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ApiList } from "../../Api/ApiList";
import { fetch_data_from_api_from_query } from "../../Api/APICalls";
import Loader from "../../Component/Loader";
import { append_all_product_menu_in_categories } from "../../utils";
import TitleHeader from "../../Component/TitleHeader/TitleHeader";
import ButtonImageGroup from "../../Component/RecursiveCategory/ButtonImage/ButtonImageGroup";
import NoProduct from "../../Component/NoProduct/NoProduct";

export default function MYC_Categories_Page() {
  const is_myc_web = useSelector(get_is_myc_web);
  const catelogue_title = useSelector(get_myc_catalogue_title);
  let my_catalogue_push_to = get_property_settings("my_catalogue_push_to");

  let [searchParams] = useSearchParams();
  const cat_id = searchParams.get("cat_id");
  const catalogueId_searchParams = searchParams.get("catalogue_id");

  my_catalogue_push_to = my_catalogue_push_to === "Category-Subcategory";
  const user_id = get_informationFromSessionID("userID");
  const catalogue_id =
    catalogueId_searchParams ||
    get_informationFromSessionID("catalogueID") ||
    "";
  const is_myc_secure = useSelector(get_myc_is_secured);
  const location = useLocation();
  const { cat_name, product_count } = location.state || {};

  const show_hide_category_counts =
    get_property_settings("show_hide_category_counts") === "show";

  const master = useSelector(getCatMaster);

  const category_for_mycatalogue_query_response = useQuery({
    queryKey: [ApiList.category_for_mycatalogue],
    queryFn: () =>
      fetch_data_from_api_from_query(
        ApiList.category_for_mycatalogue,
        ApiList.category_for_mycatalogue,
        {
          which_master: master,
          my_catalogue_id: catalogue_id,
        }
      ),
    enabled: !!my_catalogue_push_to,
  });

  const findID = (categoryData, cat_id, nestingKey) => {
    if (!Array.isArray(categoryData)) return null;
    // eslint-disable-next-line array-callback-return
    return categoryData?.reduce((result, currentItem) => {
      if (result) return result;
      if (!cat_id) return categoryData;
      if (currentItem.id === cat_id) return currentItem;
      if (currentItem[nestingKey])
        return findID(currentItem[nestingKey], cat_id, nestingKey);
    }, null);
  };

  const category_list = useMemo(() => {
    const category = append_all_product_menu_in_categories(
      category_for_mycatalogue_query_response?.data?.data,
      is_myc_web
    );

    return category?.map((cat, index) => {
      if (Array.isArray(cat?.subcategory) && cat?.subcategory.length > 1) {
        const all = {
          cat_parent_id: cat?.cat_parent_id,
          id: cat?.id,
          cat_name: "All",
          product_count: cat?.product_count,
          show_subcat: cat?.show_subcat,
          subcategory: [],
          category_img: cat?.category_img,
        };

        cat?.subcategory.unshift(all);

        return cat;
      } else {
        return cat;
      }
    });
  }, [category_for_mycatalogue_query_response?.data?.data]);

  const subCategories = useMemo(
    () => findID(category_list, cat_id, "subcategory"),
    [cat_id, category_list]
  );

  const productName = subCategories?.cat_name;
  const productCount =
    show_hide_category_counts && subCategories?.product_count !== null
      ? subCategories?.product_count
      : "";
  const title =
    !!cat_name && !!product_count
      ? `${cat_name} (${product_count})`
      : !!productName
      ? `${productName} ${productCount ? ` (${productCount})` : ""}`
      : catelogue_title;

  const subcategory = useMemo(() => {
    if (Array.isArray(subCategories?.subcategory)) {
      const subCat = [
        ...new Map(
          subCategories?.subcategory.map((obj) => [JSON.stringify(obj), obj])
        ).values(),
      ];

      if (subCat.length === 2) {
        return subCat.filter((cat) => cat?.cat_name.toLowerCase() !== "all");
      } else {
        return subCat;
      }
    } else {
      return null;
    }
  }, [subCategories?.subcategory]);

  if (!my_catalogue_push_to) {
    return <Navigate to="/" />;
  } else if (!!is_myc_secure && !user_id && !catalogueId_searchParams) {
    return <Navigate to="/login" />;
  } else if (
    !(is_myc_web && my_catalogue_push_to) &&
    !catalogueId_searchParams
  ) {
    return <Navigate to="/" />;
  }


  if (category_for_mycatalogue_query_response.isLoading)
    return <Loader isLoading={true} />;

  return (
    <section className="myc-categories-page">
      <TitleHeader title={title} />
      <section className="myc-categories-page__section">
        {!!cat_name && parseInt(product_count) === 0 ? (
          <NoProduct errMsg={"No data found"} hideHomeBtn={true} />
        ) : (
          <ButtonImageGroup
            subCategories={subcategory || subCategories}
            setShowCategoryModal={() => {}}
            layoutStyle={subCategories?.display_style_for_imagebutton}
            className="myc-button-group-card-container"
          />
        )}
      </section>
    </section>
  );
}
